<!-- 类table的列表图 -->
<style lang="less" scoped>
.table {
  width: 100%;
  height: 23vh;
  margin: -1vh auto;
  color: red;
  text-align: center;
  // overflow: hidden;
  .top {
    width: 51000/1920vw;
    height: 2000/1080vh;
    margin: 3800/1080vh 2400/1080vh 1000/1080vh;
    li {
      float: left;
      position: relative;
      height: 2000/1080vh;
      background-color: #fff;
      span {
        position: absolute;
        color: #fff;
        top: -3100/1080vh;
        right: 100/1920vw;
        // border: 1px solid #fff;
        background: url("../../../../../assets/img/yinxiao/转换率.png");
        background-size: 100% 100%;
        width: 5400/1920vw;
        height: 3000/1080vh;
        line-height: 2800/1080vh;
        // display: block;
      }
    }
    li:nth-child(1) {
      width: 8000/1920vw;
      height: 2000/1080vh;
      background: linear-gradient(
        0deg,
        rgba(27, 23, 143, 1),
        rgba(100, 95, 255, 1)
      );
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    li:nth-child(2) {
      width: 10000/1920vw;
      height: 2000/1080vh;
      background: linear-gradient(
        0deg,
        rgba(0, 136, 241, 1),
        rgba(3, 254, 241, 1)
      );
    }
    li:nth-child(3) {
      width: 5500/1920vw;
      height: 2000/1080vh;
      background: linear-gradient(
        0deg,
        rgba(90, 12, 186, 1),
        rgba(196, 121, 254, 1)
      );
    }
    li:nth-child(4) {
      width: 10000/1920vw;
      height: 2000/1080vh;
      background: linear-gradient(
        0deg,
        rgba(17, 90, 30, 1),
        rgba(190, 243, 71, 1)
      );
    }
    li:nth-child(5) {
      width: 14000/1920vw;
      height: 2000/1080vh;
      background: linear-gradient(
        0deg,
        rgba(10, 34, 216, 1),
        rgba(70, 174, 255, 1)
      );
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
  .des {
    width: 46000/1920vw;
    height: 1800/1080vh;
    margin: 0 auto;
    li {
      float: left;
      width: auto;
      line-height: 1200/1080vh;
      font-size: 1600/1080vh;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-right: 1.5vh;
      p:nth-child(1) {
        display: block;
        float: left;
        margin-right: 0.25vh;
        width: 1vh;
        height: 1vh;
      }
    }
    li:nth-child(1) p {
      background: linear-gradient(
        0deg,
        rgba(27, 23, 143, 1),
        rgba(100, 95, 255, 1)
      );
    }
    li:nth-child(2) p {
      background: linear-gradient(
        0deg,
        rgba(0, 136, 241, 1),
        rgba(3, 254, 241, 1)
      );
    }
    li:nth-child(3) p {
      background: linear-gradient(
        0deg,
        rgba(90, 12, 186, 1),
        rgba(196, 121, 254, 1)
      );
    }
    li:nth-child(4) p {
      background: linear-gradient(
        0deg,
        rgba(17, 90, 30, 1),
        rgba(190, 243, 71, 1)
      );
    }
    li:nth-child(5) p {
      background: linear-gradient(
        0deg,
        rgba(10, 34, 216, 1),
        rgba(70, 174, 255, 1)
      );
    }
  }
  .bar6 {
    // position: relative;
    // top: -1500/1080vh;
    width: 185%;
    margin-top: 1000/1080vh;
    margin-left: 2000/1080vh;
    height: 52000/1080vh;
    // zoom: 0.4;
    .main {
      width: 100%;
      height: 100%;
      transform: scale(0.5, 0.41);
      transform-origin: left top;
    }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="table">
      <ul class="top">
        <li v-for="(n, index) in tablist">
          <span v-show="index == tab">{{ n }}</span>
        </li>
      </ul>
      <ul class="des">
        <li v-for="item in data">
          <p></p>
          <span>{{ item }}</span>
        </li>
      </ul>
      <div class="bar6">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from "../common/boxWrap";
import echarts from "echarts";
export default {
  // props: ["salesData", "salesDataBar"],
  data() {
    return {
      name: "微店转化率",
      dataY: [],
      dataX: [],
      index: 0,
      tab: 0,
      tablist: ["10%", "20%", "15%", "25%", "30%"],
      data: ["领抵扣券", "大转盘", "翻牌活动", "微信红包", "刮刮乐"],
      tableData: [],
      list: {
        tableData1: [
          { value: 80, name: "宝妈" },
          { value: 60, name: "牛奶美食" },
          { value: 40, name: "纯牛奶" },
          { value: 50, name: "纸尿裤" },
          { value: 50, name: "投资理财" },
          { value: 30, name: "贝尔比" },
          { value: 20, name: "打折" },
          { value: 20, name: "天猫" },
          { value: 25, name: "双十一" },
          { value: 30, name: "周杰伦" },
          { value: 20, name: "学区房" },
          { value: 20, name: "生发素" },
          { value: 20, name: "会员" },
          // { value: 20, name: "积分" },
          { value: 25, name: "天猫" },
          { value: 30, name: "拼多多" }
        ],
        tableData2: [
          { value: 80, name: "领养一头牛" },
          { value: 60, name: "抽免单" },
          { value: 40, name: "集印花" },
          { value: 50, name: "积分兑换" },
          { value: 50, name: "微信红包" },
          { value: 30, name: "大转盘" },
          // { value: 20, name: "抵扣" },
          { value: 20, name: "翻牌" },
          { value: 20, name: "打鱼" },
          { value: 30, name: "测星座" },
          { value: 20, name: "打地鼠" },
          { value: 20, name: "签到" },
          { value: 20, name: "赛车" },
          { value: 20, name: "投篮" },
          { value: 25, name: "对对碰" },
          { value: 30, name: "刮刮乐" }
        ]
      }
    };
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function() {
          this.myChart.resize();
        }.bind(this)
      );
    },
    chart() {
      this.myChart = echarts.init(document.querySelector(".bar6 .main"));
      var option = {
        color: [
          "rgba(70,202,246,0.5)",
          "rgba(206,134,217,0.5)",
          "rgba(120,116,235,0.5)"
        ],
        calculable: true,
        series: [
          {
            type: "treemap",
            width: "100%",
            height: "100%",
            // left: "10%",
            roam: false, // 是否开启拖拽漫游（移动和缩放）
            nodeClick: false, // 点击节点后的行为,false无反应
            breadcrumb: {
              show: false
            },
            label: {
              normal: {
                textStyle: {
                  fontWeight: "bold",
                  color: "rgba(255,255,255,1)",
                  fontSize: "30"
                }
              }
            },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b}"
                },
                borderWidth: 5,
                borderColor: "transparent "
              }
            },
            data: this.tableData
          }
        ]
      };
      this.myChart.setOption(option);
    }
  },
  beforeDestroy() {},
  mounted() {
    var self = this;
    this.tableData = this.list.tableData1;
    self.chart();
    self.init();
    this.timer = setInterval(() => {
      if (this.index === 1) {
        this.tableData = this.list.tableData2;
        this.index = 2;
      } else {
        this.tableData = this.list.tableData1;
        this.index = 1;
      }
      this.chart();
    }, 15000);
    this.indextimer = setInterval(() => {
      this.tab = this.tab + 1;
      if (this.tab >= this.tablist.length) {
        this.tab = 0;
      }
    }, 3000);
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?544d49e5